/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendJwksResponseDto } from '../../models/backend-jwks-response-dto';

export interface GetJwksAuthGrafanaJwksGet$Params {}

export function getJwksAuthGrafanaJwksGet(
  http: HttpClient,
  rootUrl: string,
  params?: GetJwksAuthGrafanaJwksGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendJwksResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getJwksAuthGrafanaJwksGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendJwksResponseDto>;
    }),
  );
}

getJwksAuthGrafanaJwksGet.PATH = '/auth/grafana/jwks';
